R = require 'ramda'
usersApi = require 'api/users'
client = require 'api/auth'
Cache = require 'lru-cache'
requestUtils = require 'utils/request'
resUtil = require 'utils/resources'

{ getSearchAPIVersion } = require './api-version'

orderDetails =  """
  query OrderDetails($id: ID!){
    order(id: $id) {
      uuid
      ivr_code
      delivery_time
      due_time
      pickup_time
      confirmation_time
      state
      totals {
        total
      }
      carts {
        restaurant_id
        customer {
          name
        }
        settings {
          service {
            id
          }
          time {
            id
            value
          }
          tender {
            id
          }
        }
      }
    }
  }
  """

{ wrapRequest, wrapRequestJSON } = requestUtils

window.apiLogging = false

CACHE = new Cache
  max: 50
  maxAge: 1000 * 60 * 60
module.exports =
  search: (appliesTo, sort, dir, page, conditions) ->
    if R.equals(conditions.conditions, [])
      return {results: []}
    else
      sortParams = []
      operator = "AND"
      if sort == "placed"
        sortParams.push({field: "placed_at", order: dir})
      else
        sortParams.push({field: "order_at", order: dir}) 
      if appliesTo == "any"
        operator = "OR"
      token = client.getAuthResponse().access_token
      params = R.mergeAll [access_token: token, conditions, sort: sortParams, operator: operator, page: page, required_data: orderDetails]
      console.info "[SEARCH ORDERS]", params if window.apiLogging

      if getSearchAPIVersion(operator, conditions) == "v6"
        wrapRequestJSON client.api("#{ORDERS_SVC_API5}/v6/search", "post", params), "[get orders done]"
          .then ({results, pagination}) ->
            total = if results.length == pagination.per_page then pagination.per_page * (pagination.page + 1) else pagination.per_page * (pagination.page - 1) + results.length
            Promise.resolve({page: pagination.page, per_page: pagination.per_page, total: {relation: 'eq', value: total}, results})
      else
        wrapRequestJSON client.api("#{ORDERS_SVC_API5}/v5/search", "post", params), "[get orders done]"

  searchRaw: (appliesTo, sort, dir, page, conditions, per_page = 20) ->
    if R.equals(conditions.conditions, [])
      return {results: []}
    else
      sortParams = []
      operator = "AND"
      if sort == "placed"
        sortParams.push({field: "placed_at", order: dir})
      else
        sortParams.push({field: "order_at", order: dir}) 
      if appliesTo == "any"
        operator = "OR"
      token = client.getAuthResponse().access_token
      params = R.mergeAll [access_token: token, conditions, sort: sortParams, operator: operator, page: page, per_page: per_page]
      console.info "[SEARCH ORDERS]", params if window.apiLogging

      if getSearchAPIVersion(operator, conditions.conditions) == "v6"
        wrapRequestJSON client.api("#{ORDERS_SVC_API5}/v6/search", "post", params), "[get orders done]"
          .then ({results, pagination}) ->
            total = if results.length == pagination.per_page then pagination.per_page * (pagination.page + 1) else pagination.per_page * (pagination.page - 1) + results.length
            Promise.resolve({page: pagination.page, per_page: pagination.per_page, total: {relation: 'eq', value: total}, results})
      else
        wrapRequestJSON client.api("#{ORDERS_SVC_API5}/v5/search", "post", params), "[get orders done]"

  countOrders: (appliesTo, conditions) ->
    if R.equals(conditions.conditions, [])
      return Promise.resolve({total: 0})
    else
      operator = "AND"
      if appliesTo == "any"
        operator = "OR"
      token = client.getAuthResponse().access_token
      params = R.mergeAll [access_token: token, conditions, operator: operator]
      console.info "[COUNT ORDERS]", params if window.apiLogging

      if getSearchAPIVersion(operator, conditions.conditions) == "v6"
        wrapRequestJSON client.api("#{ORDERS_SVC_API5}/v6/search/count", "post", params), "[get orders count done]"
      else
        Promise.resolve(0)

  loadFromURL: (url, cache) ->
    if cache and data = CACHE.get(url)
      console.info "[CACHE][GET]", url if window.apiLogging
      Promise.resolve(data)
    else
      console.info "[GET]", url if window.apiLogging
      res = wrapRequest client.api(url), "[get done]"
      if cache
        res.then (data) ->
          CACHE.set url, data
          data
      res

  executeAction: (url, params) ->
    console.log "[EXECUTE ACTION]", url if window.apiLogging
    actionUrl = resUtil.fixSchema url
    wrapRequest client.api(actionUrl, 'put', params), "[execute action done]"

  executeAdjustment: (url, params) ->
    console.log "[EXECUTE ADJUSTMENT]", url if window.apiLogging
    actionUrl = resUtil.fixSchema url
    res = wrapRequestJSON client.api(actionUrl, 'post', params), "[execute adjustment done]"
    res.then (data) ->
      data

  createEvent: (url, params) ->
    console.log "[CREATE EVENT]", url if window.apiLogging
    actionUrl = resUtil.fixSchema url
    wrapRequest client.api(actionUrl, 'post', params), "[create event done]"

  createCheckin: (url) ->
    console.log "[CREATE CHECKIN]", url if window.apiLogging
    actionUrl = resUtil.fixSchema url
    res = wrapRequest client.api(actionUrl, 'post', {}), "[create Checkin done]"
    res.then (data) ->
      data

